import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { DsmProjectModelRoom, DsmProjectModelRoomsQuery } from '../models/dsm-project-model-room.models';

@Injectable({ providedIn: 'root' })
export class DsmProjectModelRoomsService {
  readonly #api = inject(ApiCallingV2Service);
  readonly #baseUrl = inject(API_CONFIG).baseUrlV2;

  /** Rooms on a model, narrowed server-side by elevation, alternate flag and active state. */
  readRooms(
    projectId: string,
    modelId: string,
    query: DsmProjectModelRoomsQuery = {}
  ): Observable<DsmProjectModelRoom[]> {
    let params = new HttpParams();

    // Repeated key, one per elevation — that is how the endpoint takes a list.
    query.elevationIds?.forEach(elevationId => {
      if (elevationId) params = params.append('elevationIds', elevationId);
    });

    if (query.alternate !== undefined) params = params.set('alternate', query.alternate);
    if (query.isActive !== undefined) params = params.set('isActive', query.isActive);

    return this.#api
      .getData<DsmProjectModelRoom[]>(`${this.#baseUrl}/project/${projectId}/model/${modelId}/rooms`, {
        showLoader: false,
        showMessage: false,
        options: { params }
      })
      .pipe(map((rooms: DsmProjectModelRoom[] | null) => rooms ?? []));
  }
}
